export default __webpack_public_path__ + "static/media/angel.da3e5027.jpg";